import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  CreateTagPayload,
  TagResponse
} from '@utils/types/organization/tag.ts';

const postTag = async (payload: CreateTagPayload): Promise<TagResponse> => {
  const { data } = await Axios.post<TagResponse>(POST_URL().createTag, payload);
  return data;
};

export const useCreateTag = () => {
  const queryClient = useQueryClient();

  return useMutation<TagResponse, AxiosError<BaseError>, CreateTagPayload>(
    postTag,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tags']);
      },
      useErrorBoundary: false
    }
  );
};
